export enum tcohV2RelatieEcgEnKlachten {
    de_patient_heeft_geen_klachten_genoteerd = 'De patiënt heeft geen klachten genoteerd',
    er_zijn_ecg_afwijkingen_echter_niet_gerelateerd_aan_klachten_namelijk = 'Er zijn ECG afwijkingen, echter niet gerelateerd aan klachten, namelijk',
    geen_bruikbaar_dagboek = 'Geen (bruikbaar) dagboek',
    tijdens_klachten_worden_atriale_en_ventriculaire_ectopie_gezien = 'Tijdens klachten worden atriale en ventriculaire ectopie gezien',
    tijdens_klachten_worden_ecg_afwijkingen_gezien_namelijk = 'Tijdens klachten worden ECG afwijkingen gezien, namelijk',
    tijdens_klachten_worden_geen_ecg_afwijkingen_gezien = 'Tijdens klachten worden geen ECG afwijkingen gezien',
    tijdens_klachten_wordt_atriale_ectopie_gezien = 'Tijdens klachten wordt atriale ectopie gezien',
    tijdens_klachten_wordt_ventriculaire_ectopie_gezien = 'Tijdens klachten wordt ventriculaire ectopie gezien',
}
